import { render, staticRenderFns } from "./mooby.vue?vue&type=template&id=52e5942d&scoped=true"
import script from "./mooby.vue?vue&type=script&lang=js"
export * from "./mooby.vue?vue&type=script&lang=js"
import style0 from "./mooby.vue?vue&type=style&index=0&id=52e5942d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5942d",
  null
  
)

export default component.exports